import axios from 'axios'

export const $axios = axios.create({
  baseURL: process.env.NODE_ENV === 'development'
    ? 'http://localhost:8000'
    : 'https://timeroot.ru',
  withCredentials: false,
  // 300 status considered valid despite axios' version
  validateStatus: status => status >= 200 && status <= 300,
})

export default Vue => {
  Vue.prototype.$axios = $axios
}
